import {
  Box, Card, CardContent, Typography,
} from '@mui/material';
import React from 'react';
import { style } from './style';

type EngineStatusCardItemProps = {
  icon: JSX.Element,
  amount: string,
  subTitle: string,
  color: string,
}

export const EngineStatusCardItem = ({
  icon,
  amount,
  subTitle,
  color,
}: EngineStatusCardItemProps):JSX.Element => {
  return (
    <Card sx={ style.Card.sx }>
      <CardContent sx={ style.CardContent.sx }>
        <Box sx={ { ...style.Box.color(color), ...style.Box.sx } }>
          <Box>{icon}</Box>
          <Box>{amount}</Box>
        </Box>
        <Typography variant="caption" sx={ style.Title.sx }>
          {subTitle}
        </Typography>
      </CardContent>
    </Card>
  );
};
